module.exports = __webpack_public_path__ + "static/media/mirror-frame.c04f1759.png";